import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { MUI } from '@styles';

const Validate = (props) => {
  const {
    // Propiedades
    status,
    myShedule,
    isSupervisor,

    // Funciones
    onApprove,
    onReject
  } = props;

  return (
    <>
      {(status === 2 && isSupervisor && !myShedule) && (
        <>
          <BoxActions>
            <MUI.ButtonCTA type="button" color="secondary" onClick={() => onReject()}>
              {i18n.t('DialogConfirm.reject')}
            </MUI.ButtonCTA>
            <MUI.ButtonCTA type="button" color="primary" onClick={() => onApprove()} >
              {i18n.t('DialogConfirm.approve')}
            </MUI.ButtonCTA>
          </BoxActions>
        </>
      )}
    </>
  );
};

Validate.propTypes = {
  // Boolean que indica si es administrador.
  status: PropTypes.number.isRequired,
  // Boolean que indica si es supervisor.
  isSupervisor: PropTypes.bool.isRequired,
  // Boolean que indica si es horario propio
  myShedule: PropTypes.bool.isRequired,
  // Función que se ejecuta cuando se aprueban el horario.
  onApprove: PropTypes.func.isRequired,
  // Función que se ejecuta cuando se rechazan el horario.
  onReject: PropTypes.func.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 0px;
`;

export default Validate;